'use client'

import { type ReactElement } from 'react'

import { CardRec } from '@/components/common/Card'
import { useBreakpoints } from '@/components/providers/BreakpointProvider'
import { type FloatingPlacementType } from '@/defs/floating'
import { type RecType } from '@/defs/rec'
import { useReduxSelector } from '@/store/hooks'

import { FloatingHoverRoot } from '../common/FloatingHoverRoot/FloatingHoverRoot'

import styles from './FloatingHoverCard.module.scss'

type Props = {
  children: ReactElement
  placement?: FloatingPlacementType
  rec: RecType
}

export const FloatingHoverCard = ({ children, placement = 'left', rec }: Props) => {
  const { isDesktop } = useBreakpoints()
  const hasModal = useReduxSelector((s) => s.modal.stack.length > 0)

  if (!isDesktop) return children

  return (
    <FloatingHoverRoot
      className={styles.container}
      forceClosed={hasModal}
      isClickable
      placement={placement}
      trigger={children}
    >
      <CardRec forceLoad rec={rec} />
    </FloatingHoverRoot>
  )
}
